import Animation from './animation'
import isEqual from 'lodash.isequal'

/*
 * This animation is used when showing a no-breakdown style chart (ie. calculated breakdown)
 * and there are stacked series. The series change order
 */
class NoBreakdownSerieStackOrderAnimation extends Animation {

  constructor (options) {
    super(options)
    this.twoPart = false
    this.ripple = false
  }

  match (serie) {
    if (!this.chart.previous) {
      return false // not an update
    }

    if (!(this.chart.previous.layout.breakdown.calculated && this.chart.layout.breakdown.calculated)) {
      // Not to/from a no-breakdown chart
      return false
    }

    let r0 = this.chart.previous.layout.breakdown.range
      , r1 = this.chart.layout.breakdown.range

    if (r0.length != r1.length) {
      // The breakdown ticks changed, not a stack order change
      return false
    }

    return r0.find((o1, idx) => {
      // If the order at this range object doesn't match, this is the animation we want.
      return !isEqual(o1.serieOrder, r1[idx].serieOrder)
    })
  }

  animate (serie, entering, selection, merged, exiting) {
    let exitingNode = exiting.selection().node()
    entering.html(exitingNode ? exiting.selection().html() : '') // Copy exiting serie into the entering
    // force all borders on the new object
    entering.selectAll('.border').data(['left', 'right', 'top', 'bottom'])
    exiting.selection().remove()

    merged.duration(this.timing.duration)
          .delay(this.timing.delay)
          .tween('decorations', this.tweeners.decorations)
          .tween('all', this.tweeners.all)
  }

}

export default NoBreakdownSerieStackOrderAnimation
